<template>
  <span
    class="text-EXPONDO-white rounded px-1 py-0.5 text-sm leading-4"
    :class="variantClass"
  >
    {{ text }}
  </span>
</template>

<script lang="ts">

export default defineComponent({
  name: 'InfoTag',
  props: {
    text: {
      type: String,
      required: true,
    },
    variant: {
      type: String as PropType<'info' | 'success'>,
      default: 'info',
    },
  },
  setup(props) {

    const variantClass = computed(() => {

      if (props.variant === 'success') {

        return 'bg-EXPONDO-green';

      }

      return 'bg-EXPONDO-secondary';

    });

    return {
      variantClass,
    };

  },
});

</script>
